import api from "./api";

/** Named CV variants, a curated view over the one profile. On `skills`/`project_ids` `null` means
 *  everything and `[]` means none — mapping null to `[]` either way swaps the two. */

/** Backend row → frontend shape, keeping null apart from `[]` (see above). */
export const mapProfileVariantDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    name: dto.name,
    title: dto.title ?? null,
    summary: dto.summary ?? null,
    skills: Array.isArray(dto.skills) ? dto.skills : null,
    projectIds: Array.isArray(dto.project_ids) ? dto.project_ids.map(String) : null,
    sortOrder: dto.sort_order ?? 0,
    createdAt: dto.created_at ?? null,
    updatedAt: dto.updated_at ?? null,
});

export const getProfileVariantsForUser = async (userId) => {
    const res = await api.get(`/ProfileVariant/${userId}`);
    return (Array.isArray(res.data) ? res.data : []).map(mapProfileVariantDto);
};

/** Creates a variant. The payload comes from `variantFormToPayload`, which decides the null
 *  semantics, and passes through untouched. */
export const createProfileVariantForUser = async (userId, payload) => {
    const res = await api.post(`/ProfileVariant/${userId}`, payload);
    return res.data;
};

export const updateProfileVariant = async (variantId, payload) => {
    const res = await api.patch(`/ProfileVariant/${variantId}`, payload);
    return res.data;
};

export const deleteProfileVariant = async (variantId) => {
    const res = await api.delete(`/ProfileVariant/${variantId}`);
    return res.data;
};
